import { AppState } from 'app/store';

export const getChatService = (state: AppState) => state.auth.services?.chat;

export const getSongChannelLink = (state: AppState) =>
  state.auth.services?.chat?._links.getChannel;

export const getCreateChatMessageLink = (state: AppState) =>
  state.auth.services?.chat?._links.createMessage;

export const getCurrentChannel = (state: AppState) => state.chat.currentChannel;

export const getLastSeenMessageTime = (state: AppState) =>
  state.chat.currentChannel?.lastReadMessageDate;

export const getCurrentChannelMessages = (state: AppState) =>
  state.chat.messages;

export const getListChatChannelsLink = (state: AppState) =>
  state.auth.services?.chat?._links.listChannels;

export const getChatChannels = (state: AppState) => state.chat.channels;

export const getChatChannelsNextLink = (state: AppState) =>
  state.chat._channelsLinks?.next;

export const getUpdateLastSeenMessageLink = (state: AppState) =>
  state.chat.currentChannel?._links.updateMyChannelUser;

export const getIsChatWindowOpened = (state: AppState) =>
  state.chat.isChatWindowOpened;

export const getChatChannelMessagesLink = (state: AppState) =>
  state.chat.currentChannel?._links.listMessages;

export const getChannelNextMessagesLink = (state: AppState) =>
  state.chat.currentChannel?._links?.next;

export const getShouldUpdateCurrentChannel = (state: AppState) =>
  state.chat.shouldUpdateChannel;

export const getSongChannelLoadingState = (state: AppState) =>
  state.chat.songChannelLoadingState;

export const getChatUnreadCountLink = (state: AppState) =>
  state.auth.services?.chat?._links?.getUnread;

export const getChatHasUnreadMessages = (state: AppState) =>
  state.chat.hasUnreadMessages;

export const getIsChannelsListOpen = (state: AppState) =>
  state.chat.isChannelsListOpen;
